import { useState } from 'react';
import { Dispatch, SetStateAction } from 'react';
import TextField from '@mui/material/TextField';
import CloseIcon from '@mui/icons-material/Close';
import { Modal, Button, } from '@mui/material'

interface AddFaqModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>
}

export default function AddFaq({ open, onClose, setOpen}: AddFaqModalProps) {
    const [question, setQuestion] = useState("");
    const [answer, setAnswer] = useState("");
    const [error, setError] = useState(false);
    return (
        <Modal
            className="modal addNotification_modal"
            open={open}
            onClose={() => {
                onClose();
                setError(false);
            }
            }
        >
            <div className="modal-dialog">
                <div className="modal-body">
                    <div className="modal_title">
                        <h2>Add FAQ</h2>
                        <div className="btn-close" onClick={() => setOpen(false)}>
                            <CloseIcon />
                        </div>
                    </div>
                    <form className="form" action="">
                        <div className="control_group">
                            <TextField
                                variant="outlined"
                                placeholder="Question"
                                fullWidth
                                value={question}
                                onChange={(e) => setQuestion(e.target.value)}
                                hiddenLabel
                            />
                            {error && question == "" ? (
                                <h6 className="err_msg">Question is required</h6>
                            ) : (
                                ""
                            )}
                        </div>
                        <div className="control_group">
                            <TextField
                                variant="outlined"
                                placeholder="Answer"
                                fullWidth
                                hiddenLabel
                                multiline
                                value={answer}
                                onChange={(e) => setAnswer(e.target.value)}
                                maxRows={5}
                                minRows={5}
                            />
                            {error && answer == "" ? (
                                <h6 className="err_msg">Answer is required</h6>
                            ) : (
                                ""
                            )}

                        </div>
                        <div className="footer_btn_flex">
                            <Button className="btn btn_grey" onClick={() => {
                                setError(false);
                                setOpen(false)
                            }}>Cancel</Button>
                            <Button className="btn btn_primary" onClick={() => {
                                setError(true);
                                if (question == "") {
                                    // showError("Question is required");
                                    return;
                                }
                                if (answer == "") {
                                    // showError("Answer is required")
                                    return;
                                }
                                setAnswer("");
                                setQuestion("");
                                setError(false);
                                setOpen(false);
                            }}>Submit</Button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal >
    )
}
